/**
 * Dynamic load more for multiple archive-pages.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;
const List = require( 'list.js' );

/**
 * Class PageFrontpage
 */
export default class PageProductCategories {

    /**
     * Cache dom elements for use in the class's methods
     *
     * @return {void}
     */
    cache() {
        this.$searchForm = $( '#js-product-categories-search-form' );
        this.$searchInput = $( '#js-product-categories-search-input' );
    }

    /**
     * All common events
     *
     * @return {void}
     */
    events() {

        // Prevent form submit and hide keyboard on mobile device.
        this.$searchForm.on( 'submit', ( e ) => {
            e.preventDefault();
            this.$searchInput.blur();
        } );
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     *
     * @return {void}
     */
    init() {
        const listOptions = {
            valueNames: [
                {
                    name: 'product-categories__grid__item__name',
                    attr: 'data-search-name',
                },
                'product-categories__grid__item__tags',
            ],
        };

        new List( 'js-product-categories', listOptions );
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
        this.init();
    }
}
